import React, {useContext, useEffect, useState} from "react"
import PropTypes from "prop-types"
import SearchContext from "../context/SearchContext"
import AnalyticsContext from "../context/AnalyticsContext"
import {gaCategories, gaEvents} from "../config/googleAnalytics/events"
import {performSearchOnFrontEnd} from "../search/handleSearch"
import useCache from "../hooks/useCache"
import {logger} from "../utility/Helper"

type Props = {
    children: React.ReactNode
}

const SearchContextProvider: React.FC<Props> = ({children}) => {
	const [isOn, toggle] = useState(false)
	const [isLoading, setLoading] = useState(false)
	const [results, setResults] = useState(null)
	const [value, setValue] = useState(null)
	const [queuedSearch, setQueuedSearch] = useState(false)
	const [termValue, setTermValue] = useState("")
	const {reactGA} = useContext(AnalyticsContext)
	const {data: searchIndex, isLoading: loading} = useCache("/api/products/get-search-index?locale=de&limit=1500&offset=0")

	const handleSearch = async term => {
		try {
			setLoading(true)
			reactGA?.event({
				category: gaCategories.search,
				action: gaEvents.searchTerm,
				label: `${gaEvents.searchTerm} | ${term}`,
				nonInteraction: false
			})
			logger.info("search triggered")
			if (loading && !searchIndex?.direct?.bikes?.length) {
				logger.info("still waiting for index to load")
				setQueuedSearch(true)
				return
			}

			performSearchOnFrontEnd(term, searchIndex?.direct, setResults, setLoading)
		} catch (e) {
			console.error("Could not send search term event", e)
		}
	}

	useEffect(() => {
		if (queuedSearch && searchIndex?.direct?.bikes?.length && termValue) {
			handleSearch(termValue).finally(() => setQueuedSearch(false))
		}
	}, [isLoading, searchIndex?.direct?.bikes?.length])

	return (
		<SearchContext.Provider value={{isOn, toggle, isLoading, setLoading, results, setResults, value, setValue, handleSearch, termValue, setTermValue}}>
			{children}
		</SearchContext.Provider>
	)
}

SearchContextProvider.propTypes = {
	children: PropTypes.node
}

export default SearchContextProvider
